import * as React from "react"

import { cn } from "../../lib/utils"

type HugeiconComponent = React.ComponentType<
  Omit<React.ComponentPropsWithoutRef<"svg">, "strokeWidth"> & {
    size?: number | string
    color?: string
    strokeWidth?: number
  }
>

interface HugeiconsIconProps extends Omit<React.ComponentPropsWithoutRef<"svg">, "strokeWidth"> {
  icon: HugeiconComponent
  size?: number | string
  strokeWidth?: number
}

export function HugeiconsIcon({
  icon: Icon,
  size = 16,
  className,
  strokeWidth,
  ...props
}: HugeiconsIconProps) {
  return <Icon size={size} strokeWidth={strokeWidth} className={cn("shrink-0", className)} {...props} />
}
